import React from "react";

import { Button, Row, Col } from "reactstrap";

import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";

const AppAd = () => {
  const { t } = useTranslation();

  return (
    <Row>
      <Col sm="12" className="d-none d-md-block">
        <img
          className="w-100"
          src={require("@imgs/app-ad.png").default}
          alt={`${t("site_name")} mobile app`}
        />
      </Col>
      <Col
        sm="12"
        md="6"
        className="position-absolute text-white text-center text-md-start px-4 py-3 py-md-0 top-50 start-50 translate-middle fw-bolder app-ad-content "
      >
        <p className="pb-0 mb-1 mb-md-50 mb-lg-1">
          {t("learn_more_about_our_solution")}
          <Link
            to="/how-it-works"
            className="ms-50 text-white text-decoration-underline"
          >
            {t("here")}
          </Link>
          <br /> {t("better_download_app")}
        </p>
        <h5 className="pb-0 mb-1 mb-md-50 mb-lg-1 fw-bolder text-white">
          {t("available_on")}
        </h5>
        <div className="d-flex gap-1  justify-content-center d-md-block text-center text-md-start">
          <Button.Ripple
            className="me-0 me-md-1 p-0 app-add__store-btn"
            color="flat"
            size="sm"
            tag={"a"}
            href={process.env.REACT_APP_APP_STORE_URL}
            target="_blank"
          >
            <img
              src={require("@imgs/app-store-btn.png").default}
              alt={`${t("site_name")} mobile app app-store`}
            />
          </Button.Ripple>
          <Button.Ripple
            className="me-0 me-md-1 p-0 app-add__store-btn"
            color="flat"
            size="sm"
            tag={"a"}
            href={process.env.REACT_APP_GOOGLE_PLAY_APP_URL}
            target="_blank"
          >
            <img
              src={require("@imgs/google-play-btn.png").default}
              alt={`${t("site_name")} mobile app google play`}
            />
          </Button.Ripple>
        </div>
      </Col>
    </Row>
  );
};

export default AppAd;
